import './styles.scss';

import React from 'react';

import TeamsAPI from '../../../utils/teamsAPI';

import TeamDisplayModule from '../teamDisplayModule';
import TeamsByDivisionList from '../teamsByDivisionList';
import TeamsByConferenceList from '../teamsByConferenceList';
import TeamsByLeagueList from '../teamsByLeagueList';

import { groupBy } from '../teamsList';
import { teamsListPropTypes } from './propTypes';

const TeamsList = ({teams, season, layoutClasses = '', toggleTeamFilter = () => {}, ...props}) => {

    let views;

    switch (props.groupBy) {
        case groupBy.CONFERENCE:
            let conferences = TeamsAPI.getTeamsByConference(teams);

            views = conferences.map(conference =>
                <TeamsByConferenceList
                    key={ conference.id }
                    conference={ conference }
                    season={ season }
                    { ...props }
                />
            );

        break;

        case groupBy.DIVISION:
            const divisions = TeamsAPI.getTeamsByDivision(teams);

            views = divisions.map(division =>
                <TeamsByDivisionList
                    key={ division.id }
                    division={ division }
                    season={ season }
                    { ...props }
                />
            );

        break;

        case groupBy.LEAGUE:
            views = (
                <TeamsByLeagueList
                    teams={ teams || [] }
                    season={ season } { ...props }
                />
            );

        break;

        default:
            views = teams.map((team) =>
                <TeamDisplayModule
                    key={ team.id }
                    team={ team }
                    season={ season }
                    { ...props }
                />
            );
    }

    return (
        <div className={`teams-list-container ${layoutClasses}`} onScroll={props.onScroll}>
            <div className="teams-list">
                { views }
            </div>
        </div>
    )
};

TeamsList.propTypes = teamsListPropTypes;

export default TeamsList;
